import React, { useState, useContext, useEffect } from "react";
import { Typography, Grid } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab/";
import initialState from "../../../utils/initialState";
import { questions } from "../../../utils/databaseQuestions";
import { useStyles } from "../../../assets/styles";
import QuestionContainer from "../../CustomForms/QuestionContainer/QuestionContainer";
import ButtonWithStyle from "../../../HOCs/ButtonWithStyle/ButtonWithStyle";
import { Redirect, useLocation, Link } from "react-router-dom";
import PublishIcon from "@material-ui/icons/Publish";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

import validateFormHandler, {
	updateFeedWithImageUrl,
	updateInfoTODB,
	getDataFromDB,
} from "../../../utils/menuFormHandler";
import { AuthContext } from "../../../AuthContext";

export default function AddMenuForm({ isLoading, handleProgress, handleLoading }) {
	const location = useLocation();
	const data = initialState(questions);
	const initPosition = { level: 0, subLevel: 0 };
	const [formData, setFormData] = useState(data);
	const [currentDisplayedForm, setCurrentDisplayedForm] = useState(initPosition);
	const [docID, setDocID] = useState("");
	const [lastPosition, setLastPosition] = useState([initPosition]);
	const [warning, setWarning] = useState("");
	const [questionsWithCategories, setQuestionsWithCategories] = useState(questions);
	const [redirect, setRedirect] = useState(false);

	const {
		databasesRef: { menuDB, parentMenuDB, nameDB },
	} = useContext(AuthContext);

	const handleCurrentDisplayForm = (next, back) => {
		if (back) {
			const returnedPosition = lastPosition.slice(0, lastPosition.length - 1);
			setLastPosition(returnedPosition);
			setCurrentDisplayedForm(returnedPosition[returnedPosition.length - 1]);
		} else {
			setLastPosition([...lastPosition, next]);
			setCurrentDisplayedForm(next);
		}
	};

	const handleChange = (e) => {
		const { name, value, type, checked } = e.target;
		const newValue = type === "checkbox" ? checked : value;
		if (warning) setWarning("");
		setFormData({
			...formData,
			[name]: newValue,
		});
	};

	const handleFormData = (value) => {
		setFormData(value);
	};

	const resetFormData = () => {
		setFormData(data);
		setRedirect(true);
		setDocID("");
	};

	useEffect(() => {
		if (location.search && menuDB) {
			async function retrieveFromDataBase() {
				const docID = location.search.slice(1);
				const initialStateData = initialState(questions);
				const newData = await getDataFromDB({ db: menuDB, id: docID });
				setFormData({ ...initialStateData, ...newData });
				setDocID(docID);
			}
			retrieveFromDataBase();
		}
	}, [location, menuDB]);

	useEffect(() => {
		if (parentMenuDB) {
			return parentMenuDB.onSnapshot((doc) => {
				const categories = doc?.data()?.categories?.map((category) => category.name) || [];
				const questionsUpdated = questions.map((question) => {
					if (question.id === "category") {
						return { ...question, options: categories };
					}
					return question;
				});
				setQuestionsWithCategories(questionsUpdated);
			});
		}
	}, [parentMenuDB]);

	const classes = useStyles();
	const topLevel = { level: 0, subLevel: 0, position: null };

	const handleSubmit = (e) => {
		e.preventDefault();
		async function uploadData() {
			handleLoading(true);
			try {
				const validatedData = await validateFormHandler(formData);
				const payload = { data: validatedData, handleProgress, nameDB };
				const dataWithUrls = await updateFeedWithImageUrl(payload);
				const args = { data: dataWithUrls, db: menuDB, docID };
				handleProgress("Subiendo información", 0);
				const message = await updateInfoTODB(args);
				handleProgress("Subiendo información", 100);
				alert(message);
				resetFormData();
			} catch (error) {
				console.log(error);
				setWarning(String(error));
			}
			handleLoading(false);
		}
		uploadData();
	};

	const isTopLevel = currentDisplayedForm.level === 0 && currentDisplayedForm.subLevel === 0;

	const submitButton = isTopLevel && (
		<>
			<Link to="/menu" style={{ textDecoration: "none" }}>
				<ButtonWithStyle className={classes.returnButton}>
					<ArrowBackIosIcon />
					Regresar
				</ButtonWithStyle>
			</Link>
			<ButtonWithStyle type="submit">
				<PublishIcon />
				Agregar al menu
			</ButtonWithStyle>
		</>
	);

	const AlertNotification = warning && (
		<Alert severity="warning">
			<AlertTitle>{warning}</AlertTitle>Debe llenar todos los campos requeridos, incluso dentro de subCategorias y
			opciones
		</Alert>
	);

	const form = (
		<form onSubmit={handleSubmit}>
			{AlertNotification}
			<Typography variant="h5">Nuevo Menu</Typography>
			<Grid container spacing={3} className={classes?.grid}>
				<QuestionContainer
					formLevel={topLevel}
					currentDisplayedForm={currentDisplayedForm}
					handleChange={handleChange}
					handleCurrentDisplayForm={handleCurrentDisplayForm}
					questions={questionsWithCategories}
					formData={formData}
					globalFormData={formData}
					handleFormData={handleFormData}
				/>
			</Grid>
			{submitButton}
		</form>
	);

	return (
		<>
			{redirect && <Redirect to="/add" />}
			{!isLoading && form}
		</>
	);
}
